import axios from "axios"

export const useKeepAlive = () => {
    const set = () => {
        setInterval(() => axios.get("/keep-alive"), 600000) // 10分
    }

    return {
        set,
    }
}
